import { cn } from "@netlify/ui";
import type { AlertState } from "./types";

const STATES: Record<
  AlertState,
  { className: string; iconClassName?: string }
> = {
  error: {
    className:
      "tw-bg-red-lightest tw-text-red-darkest dark:tw-bg-red-darkest dark:tw-text-red-lighter",
  },
  warning: {
    className:
      "tw-bg-gold-lightest tw-text-gold-darkest dark:tw-bg-gold-darkest dark:tw-text-gold-lighter",
  },
  info: {
    className:
      "tw-bg-gray-lightest tw-text-black dark:tw-bg-gray-darker dark:tw-text-gray-lighter",
  },
  success: {
    className:
      "tw-bg-green-lightest tw-text-green-darkest dark:tw-bg-green-darkest dark:tw-text-green-lighter",
  },
  upgrade: {
    className:
      "tw-bg-blue-lightest tw-text-blue-darkest dark:tw-bg-blue-darkest dark:tw-text-blue-lightest",
    iconClassName: "tw-text-blue dark:tw-text-blue-lighter",
  },
};

export const alertCN = ({
  outset,
  state,
  className,
}: {
  outset: string | undefined;
  state: AlertState;
  className: string | undefined;
}) =>
  cn(
    "tw-relative tw-z-1 tw-mx-auto tw-box-border tw-flex tw-w-full tw-items-start tw-rounded-sm tw-p-4 tw-text-left tw-text-sm",
    outset,
    STATES[state].className,
    className,
  );

export const contentsCN = "tw-min-h-4 tw-grow tw-overflow-visible";

export const iconCN = ({
  state,
  iconClassName,
}: {
  state: AlertState;
  iconClassName: string | undefined;
}) =>
  cn(
    "tw-mr-2 tw-mt-0.5 tw-shrink-0",
    STATES[state].iconClassName,
    iconClassName,
  );

export const dismissButtonCN =
  "tw--m-2 tw-text-black hover:!tw-bg-transparent hover:!tw-text-inherit dark:tw-text-white";
